module.exports = __webpack_public_path__ + "img/page1.708b1a8d.png";